import { useEffect, useState } from "react";
import { Transition } from "@headlessui/react";

export default function Loader({ show }) {
  const [activeIcon, setActiveIcon] = useState(0);
  const [time, setTime] = useState(0);

  //console.log("yo")

  useEffect(() => {
    let count = 0;
    function changeIcon() {
      window.requestAnimationFrame(() => {
        count++;
        setTime(count);
        if (count > 70) {
          setActiveIcon((prevState) => (prevState >= 4 ? 0 : prevState + 1));
          count = 0;
          setTime(0);
        }
        changeIcon();
      });
    }
    changeIcon();
  }, []);

  return (
    <Transition
      show={show}
      enter="transition-opacity ease-linear duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity ease-linear duration-300"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="h-screen w-full bg-[rgba(112,41,99,0.45)] top-0 left-0 flex flex-col justify-center items-center fixed">
        <span className={`${activeIcon === 0 ? "block" : "hidden"}`}>
          <svg
            width="88"
            height="88"
            viewBox="0 0 88 88"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.33398 21.9993C7.33398 21.9993 12.834 14.666 25.6673 14.666C38.5007 14.666 44.0007 21.9993 44.0007 21.9993V73.3327C44.0007 73.3327 38.5007 69.666 25.6673 69.666C12.834 69.666 7.33398 73.3327 7.33398 73.3327V21.9993Z"
              stroke="#702963"
              stroke-width="8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M44 21.9993C44 21.9993 49.5 14.666 62.3333 14.666C75.1667 14.666 80.6667 21.9993 80.6667 21.9993V73.3327C80.6667 73.3327 75.1667 69.666 62.3333 69.666C49.5 69.666 44 73.3327 44 73.3327V21.9993Z"
              stroke="#702963"
              stroke-width="8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <span className={`${activeIcon === 1 ? "block" : "hidden"}`}>
          <svg
            width="88"
            height="88"
            viewBox="0 0 88 88"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M44 32.9993C52.1033 32.9993 58.6667 26.436 58.6667 18.3327C58.6667 10.2293 52.1033 3.66602 44 3.66602C35.8967 3.66602 29.3333 10.2293 29.3333 18.3327C29.3333 26.436 35.8967 32.9993 44 32.9993ZM44 10.9993C48.0333 10.9993 51.3333 14.2993 51.3333 18.3327C51.3333 22.366 48.0333 25.666 44 25.666C39.9667 25.666 36.6667 22.366 36.6667 18.3327C36.6667 14.2993 39.9667 10.9993 44 10.9993ZM44 42.3493C35.3467 34.2827 23.76 29.3327 11 29.3327V69.666C23.76 69.666 35.3467 74.616 44 82.6827C52.6533 74.6527 64.24 69.666 77 69.666V29.3327C64.24 29.3327 52.6533 34.2827 44 42.3493ZM69.6667 62.8093C60.39 64.056 51.59 67.576 44 73.1493C36.4467 67.576 27.61 64.0193 18.3333 62.7727V37.2893C26.0333 38.6827 33.1833 42.2393 39.0133 47.666L44 52.3593L48.9867 47.7027C54.8167 42.276 61.9667 38.7193 69.6667 37.326V62.8093Z"
              fill="#702963"
            />
          </svg>
        </span>
        <span className={`${activeIcon === 2 ? "block" : "hidden"}`}>
          <svg
            width="88"
            height="88"
            viewBox="0 0 88 88"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M48.2946 63.2852L13.3569 63.2912H13.3566C10.9509 63.2912 8.99944 61.3397 8.99944 58.934V16.4992C8.99944 15.3436 9.4585 14.2353 10.2756 13.4182C11.0927 12.6011 12.201 12.142 13.3566 12.142H74.6392C75.7948 12.142 76.903 12.6011 77.7201 13.4182C78.5372 14.2353 78.9963 15.3436 78.9963 16.4992V58.9326V58.934H76.9963C76.9966 59.2747 76.9228 59.6113 76.78 59.9206L48.2946 63.2852ZM48.2946 63.2852V64.0055H36.1423H34.1423V66.0055V73.8563V75.8563H36.1423H48.2883V76.5706H25.9286C25.8381 76.5706 25.751 76.5362 25.6849 76.4744C25.6188 76.4126 25.5786 76.3281 25.5724 76.2378C25.5663 76.1475 25.5946 76.0583 25.6517 75.9881C25.7007 75.9278 25.7678 75.8855 25.8425 75.8669L25.9965 75.8563H31.428H33.428V73.8563V66.0055V64.0055H31.428H13.3566C12.0116 64.0055 10.7216 63.4711 9.77054 62.5201L8.37091 63.9197L9.77054 62.5201C8.81946 61.569 8.28516 60.279 8.28516 58.934V16.4992C8.28516 15.1541 8.81947 13.8642 9.77054 12.9131C10.7216 11.962 12.0116 11.4277 13.3566 11.4277H74.6392C75.9842 11.4277 77.2741 11.962 78.2252 12.9131C79.1763 13.8642 79.7106 15.1541 79.7106 16.4992V58.934C79.7106 59.7163 79.5341 60.4568 79.2178 61.1184L78.6917 60.5352L48.2946 63.2852ZM55.6499 46.0332L55.6757 46.0233C55.7431 45.9974 55.8167 45.9926 55.887 46.0094C55.9572 46.0263 56.0206 46.064 56.069 46.1176L56.0693 46.118L80.284 72.9694C80.2843 72.9697 80.2846 72.9701 80.2849 72.9704C80.3355 73.027 80.3667 73.0983 80.374 73.1739C80.3814 73.2499 80.3642 73.3264 80.3249 73.3919C80.2856 73.4574 80.2264 73.5087 80.1558 73.538C80.0853 73.5674 80.0072 73.5734 79.933 73.5551L66.1388 70.1301L64.7799 69.7927L63.9979 70.9541L56.0814 82.7111L55.6499 46.0332ZM55.6499 46.0332C55.5935 46.0602 55.545 46.1016 55.5095 46.1534L55.4475 46.111L55.5095 46.1534C55.4687 46.2129 55.4468 46.2834 55.4469 46.3556V46.3573L55.428 82.5116C55.428 82.5117 55.428 82.5119 55.428 82.5121C55.4281 82.5884 55.4527 82.6627 55.4981 82.724C55.5436 82.7855 55.6077 82.8308 55.6808 82.8531C55.754 82.8754 55.8324 82.8737 55.9045 82.8481C55.9765 82.8226 56.0383 82.7747 56.0811 82.7115L55.6499 46.0332Z"
              fill="#702963"
              stroke="#702963"
              stroke-width="4"
            />
          </svg>
        </span>
        <span className={`${activeIcon === 3 ? "block" : "hidden"}`}>
          <svg
            width="88"
            height="88"
            viewBox="0 0 88 88"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 29.334V69.6673C11 77.7377 17.578 80.6673 22 80.6673H77V73.334H22.044C20.35 73.29 18.3333 72.6227 18.3333 69.6673C18.3333 69.297 18.3663 68.967 18.4213 68.6663C18.832 66.5543 20.5627 66.0373 22.044 66.0007H77V14.6673C77 10.623 73.711 7.33398 69.6667 7.33398H22C17.578 7.33398 11 10.2637 11 18.334V29.334ZM22 14.6673H69.6667V58.6673H18.3333V18.334C18.3333 15.3787 20.35 14.7113 22 14.6673Z"
              fill="#702963"
            />
            <path
              d="M40.334 51.3333H47.6673V40.3333H58.6673V33H47.6673V22H40.334V33H29.334V40.3333H40.334V51.3333Z"
              fill="#702963"
            />
          </svg>
        </span>
        <span className={`${activeIcon === 4 ? "block" : "hidden"}`}>
          <svg
            width="88"
            height="88"
            viewBox="0 0 88 88"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M43.9997 25.6667V11H7.33301V77H80.6663V25.6667H43.9997ZM21.9997 69.6667H14.6663V62.3333H21.9997V69.6667ZM21.9997 55H14.6663V47.6667H21.9997V55ZM21.9997 40.3333H14.6663V33H21.9997V40.3333ZM21.9997 25.6667H14.6663V18.3333H21.9997V25.6667ZM36.6663 69.6667H29.333V62.3333H36.6663V69.6667ZM36.6663 55H29.333V47.6667H36.6663V55ZM36.6663 40.3333H29.333V33H36.6663V40.3333ZM36.6663 25.6667H29.333V18.3333H36.6663V25.6667ZM73.333 69.6667H43.9997V62.3333H51.333V55H43.9997V47.6667H51.333V40.3333H43.9997V33H73.333V69.6667ZM65.9997 40.3333H58.6663V47.6667H65.9997V40.3333ZM65.9997 55H58.6663V62.3333H65.9997V55Z"
              fill="#702963"
            />
          </svg>
        </span>
        <span className={`${activeIcon === 5 ? "block" : "hidden"}`}>
          <svg
            width="88"
            height="88"
            viewBox="0 0 88 88"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M44 10.7422L42.9688 11.1712L9.96875 24.9212L8.25 25.6994V33.0007H13.75V63.2507H8.25V77.0007H79.75V63.2507H74.25V33.0007H79.75V25.6967L78.0312 24.9267L45.0312 11.1712L44 10.7422ZM44 16.7592L69.7812 27.5007H18.2188L44 16.7592ZM19.25 33.0007H24.75V63.2507H19.25V33.0007ZM30.25 33.0007H35.75V63.2507H30.25V33.0007ZM41.25 33.0007H46.75V63.2507H41.25V33.0007ZM52.25 33.0007H57.75V63.2507H52.25V33.0007ZM63.25 33.0007H68.75V63.2507H63.25V33.0007ZM13.75 68.7507H74.25V71.5007H13.75V68.7507Z"
              fill="#702963"
            />
          </svg>
        </span>
        <div className="flex justify-between items-center mt-2 w-20 h-4">
          <span
            className={`w-4 h-4 rounded-full ${
              time < 20 ? "bg-neutral-10" : "bg-primary-dark"
            } mr-3`}
          ></span>
          <span
            className={`w-4 h-4 rounded-full ${
              time < 40 ? "bg-neutral-10" : "bg-primary-dark"
            } mr-3`}
          ></span>
          <span
            className={`w-4 h-4 rounded-full ${
              time < 58 ? "bg-neutral-10" : "bg-primary-dark"
            }`}
          ></span>
        </div>
      </div>
    </Transition>
  );
}
